import React, { useState, useEffect } from "react";
import i18n from "i18next";
import { baseUrl } from "../../helpers/constants";

interface IImageProps {
  src: string;
  alt: string;
}

export function QuickFinderHelpImages() {
  const getImage = (type: string, property: string) => {
    switch (type) {
      case "allLsp3":
        break;
      case "lsp3_o_inline":
        switch (property) {
          case "minOeffnung": {
            const imageProps: IImageProps = {
              src: `${baseUrl}/IMAGES/HELPIMAGES/INLINE_OFFEN/MIN_OEFFNUNGSWEITE.JPG`,
              alt: i18n.t<string>("oeffnungsweite"),
            };
            return imageProps;
          }
          case "maxKopfmass": {
            const imageProps: IImageProps = {
              src: `${baseUrl}/IMAGES/HELPIMAGES/INLINE_OFFEN/MAX_KOPFMASS.JPG`,
              alt: i18n.t<string>("maxKopfmass"),
            };
            return imageProps;
          }
          case "maxKlingenstaerke": {
            const imageProps: IImageProps = {
              src: `${baseUrl}/IMAGES/HELPIMAGES/INLINE_OFFEN/MAX_KLINGENSTAERKE.JPG`,
              alt: i18n.t<string>("maxKlingenstaerke"),
            };
            return imageProps;
          }
          case "maxBreite": {
            const imageProps: IImageProps = {
              src: `${baseUrl}/IMAGES/HELPIMAGES/INLINE_OFFEN/MAX_BREITE.JPG`,
              alt: i18n.t<string>("maxBreite"),
            };
            return imageProps;
          }
          case "minAchsabstand": {
            const imageProps: IImageProps = {
              src: `${baseUrl}/IMAGES/HELPIMAGES/INLINE_OFFEN/MIN_MAX_ACHSABSTAND.JPG`,
              alt: i18n.t<string>("minAchsabstand"),
            };
            return imageProps;
          }
          case "maxAchsabstand": {
            const imageProps: IImageProps = {
              src: `${baseUrl}/IMAGES/HELPIMAGES/INLINE_OFFEN/MIN_MAX_ACHSABSTAND.JPG`,
              alt: i18n.t<string>("maxAchsabstand"),
            };
            return imageProps;
          }
          case "minAuskragung": {
            const imageProps: IImageProps = {
              src: `${baseUrl}/IMAGES/HELPIMAGES/INLINE_OFFEN/MIN_AUSKRAGUNG.JPG`,
              alt: i18n.t<string>("minAuskragung"),
            };
            return imageProps;
          }
          case "maxRadius": {
            const imageProps: IImageProps = {
              src: `${baseUrl}/IMAGES/HELPIMAGES/INLINE_OFFEN/MAX_RADIUS.JPG`,
              alt: i18n.t<string>("maxRadius"),
            };
            return imageProps;
          }
          case "abtriebsprofil": {
            const imageProps: IImageProps = {
              src: `${baseUrl}/IMAGES/HELPIMAGES/INLINE_OFFEN/ANTRIEBSPROFIL.JPG`,
              alt: i18n.t<string>("abtriebsprofil"),
            };
            return imageProps;
          }
        }
        break;
      case "lsp3_c_inline":
        switch (property) {
          case "maxKopfmass": {
            const imageProps: IImageProps = {
              src: `${baseUrl}/IMAGES/HELPIMAGES/INLINE_GESCHLO/MAX_KOPFMASS.JPG`,
              alt: i18n.t<string>("maxKopfmass"),
            };
            return imageProps;
          }
          case "maxKlingenstaerke": {
            const imageProps: IImageProps = {
              src: `${baseUrl}/IMAGES/HELPIMAGES/INLINE_GESCHLO/MAX_KLINGENSTAERKE.JPG`,
              alt: i18n.t<string>("maxKlingenstaerke"),
            };
            return imageProps;
          }
          case "maxBreite": {
            const imageProps: IImageProps = {
              src: `${baseUrl}/IMAGES/HELPIMAGES/INLINE_GESCHLO/MAX_BREITE.JPG`,
              alt: i18n.t<string>("maxBreite"),
            };
            return imageProps;
          }
          case "minAchsabstand": {
            const imageProps: IImageProps = {
              src: `${baseUrl}/IMAGES/HELPIMAGES/INLINE_GESCHLO/MIN_MAX_ACHSABSTAND.JPG`,
              alt: i18n.t<string>("minAchsabstand"),
            };
            return imageProps;
          }
          case "maxAchsabstand": {
            const imageProps: IImageProps = {
              src: `${baseUrl}/IMAGES/HELPIMAGES/INLINE_GESCHLO/MIN_MAX_ACHSABSTAND.JPG`,
              alt: i18n.t<string>("maxAchsabstand"),
            };
            return imageProps;
          }
          case "minAuskragung": {
            const imageProps: IImageProps = {
              src: `${baseUrl}/IMAGES/HELPIMAGES/INLINE_GESCHLO/MIN_AUSKRAGUNG.JPG`,
              alt: i18n.t<string>("minAuskragung"),
            };
            return imageProps;
          }
          case "abtriebsprofil": {
            const imageProps: IImageProps = {
              src: `${baseUrl}/IMAGES/HELPIMAGES/INLINE_GESCHLO/ABTRIEBSPROFIL.JPG`,
              alt: i18n.t<string>("abtriebsprofil"),
            };
            return imageProps;
          }
          case "maxRadius": {
            const imageProps: IImageProps = {
              src: `${baseUrl}/IMAGES/HELPIMAGES/INLINE_GESCHLO/MAX_RADIUS.JPG`,
              alt: i18n.t<string>("maxRadius"),
            };
            return imageProps;
          }
        }
        break;
      case "lsp3_o_outline":
        switch (property) {
          case "minOeffnung": {
            const imageProps: IImageProps = {
              src: `${baseUrl}/IMAGES/HELPIMAGES/FL_OFFEN/MIN_OEFFNUNGSWEITE.JPG`,
              alt: i18n.t<string>("oeffnungsweite"),
            };
            return imageProps;
          }
          case "maxKopfmass": {
            const imageProps: IImageProps = {
              src: `${baseUrl}/IMAGES/HELPIMAGES/FL_OFFEN/MAX_KOPFMASS.JPG`,
              alt: i18n.t<string>("maxKopfmass"),
            };
            return imageProps;
          }
          case "maxKlingenstaerke": {
            const imageProps: IImageProps = {
              src: `${baseUrl}/IMAGES/HELPIMAGES/FL_OFFEN/MAX_KLINGENSTAERKE.JPG`,
              alt: i18n.t<string>("maxKlingenstaerke"),
            };
            return imageProps;
          }
          case "maxBreite": {
            const imageProps: IImageProps = {
              src: `${baseUrl}/IMAGES/HELPIMAGES/FL_OFFEN/MAX_BREITE.JPG`,
              alt: i18n.t<string>("maxBreite"),
            };
            return imageProps;
          }
          case "minAchsabstand": {
            const imageProps: IImageProps = {
              src: `${baseUrl}/IMAGES/HELPIMAGES/FL_OFFEN/MIN_MAX_ACHSABSTAND.JPG`,
              alt: i18n.t<string>("minAchsabstand"),
            };
            return imageProps;
          }
          case "maxRadius": {
            const imageProps: IImageProps = {
              src: `${baseUrl}/IMAGES/HELPIMAGES/FL_OFFEN/MAX_RADIUS.JPG`,
              alt: i18n.t<string>("maxRadius"),
            };
            return imageProps;
          }
          case "maxAchsabstand": {
            const imageProps: IImageProps = {
              src: `${baseUrl}/IMAGES/HELPIMAGES/FL_OFFEN/MIN_MAX_ACHSABSTAND.JPG`,
              alt: i18n.t<string>("maxAchsabstand"),
            };
            return imageProps;
          }
          case "minAuskragung": {
            const imageProps: IImageProps = {
              src: `${baseUrl}/IMAGES/HELPIMAGES/FL_OFFEN/MIN_AUSKRAGUNG.JPG`,
              alt: i18n.t<string>("minAuskragung"),
            };
            return imageProps;
          }
          case "abtriebsprofil": {
            const imageProps: IImageProps = {
              src: `${baseUrl}/IMAGES/HELPIMAGES/FL_OFFEN/ABTRIEBSPROFIL.JPG`,
              alt: i18n.t<string>("abtriebsprofil"),
            };
            return imageProps;
          }
        }
        break;
      case "lsp3_c_outline":
        switch (property) {
          case "maxKopfmass": {
            const imageProps: IImageProps = {
              src: `${baseUrl}/IMAGES/HELPIMAGES/FL_GESCHL/MAX_KOPFMASS.JPG`,
              alt: i18n.t<string>("maxKopfmass"),
            };
            return imageProps;
          }
          case "maxKlingenstaerke": {
            const imageProps: IImageProps = {
              src: `${baseUrl}/IMAGES/HELPIMAGES/FL_GESCHL/MAX_KLINGENSTAERKE.JPG`,
              alt: i18n.t<string>("maxKlingenstaerke"),
            };
            return imageProps;
          }
          case "maxBreite": {
            const imageProps: IImageProps = {
              src: `${baseUrl}/IMAGES/HELPIMAGES/FL_GESCHL/MAX_BREITE.JPG`,
              alt: i18n.t<string>("maxBreite"),
            };
            return imageProps;
          }
          case "minAchsabstand": {
            const imageProps: IImageProps = {
              src: `${baseUrl}/IMAGES/HELPIMAGES/FL_GESCHL/MIN_MAX_ACHSABSTAND.JPG`,
              alt: i18n.t<string>("minAchsabstand"),
            };
            return imageProps;
          }
          case "maxAchsabstand": {
            const imageProps: IImageProps = {
              src: `${baseUrl}/IMAGES/HELPIMAGES/FL_GESCHL/MIN_MAX_ACHSABSTAND.JPG`,
              alt: i18n.t<string>("maxAchsabstand"),
            };
            return imageProps;
          }
          case "minAuskragung": {
            const imageProps: IImageProps = {
              src: `${baseUrl}/IMAGES/HELPIMAGES/FL_GESCHL/MIN_AUSKRAGUNG.JPG`,
              alt: i18n.t<string>("minAuskragung"),
            };
            return imageProps;
          }
          case "abtriebsprofil": {
            const imageProps: IImageProps = {
              src: `${baseUrl}/IMAGES/HELPIMAGES/FL_GESCHL/ABTRIEBSPROFIL.JPG`,
              alt: i18n.t<string>("abtriebsprofil"),
            };
            return imageProps;
          }
          case "maxRadius": {
            const imageProps: IImageProps = {
              src: `${baseUrl}/IMAGES/HELPIMAGES/FL_GESCHL/MAX_RADIUS.JPG`,
              alt: i18n.t<string>("maxRadius"),
            };
            return imageProps;
          }
        }
        break;
      case "abtriebszahnrad":
        switch (property) {
          case "maxLaenge": {
            const imageProps: IImageProps = {
              src: `${baseUrl}/IMAGES/HELPIMAGES/ZAB/MAX_LAENGE.JPG`,
              alt: i18n.t<string>("maxLaenge"),
            };
            return imageProps;
          }
          case "minAussenlaenge": {
            const imageProps: IImageProps = {
              src: `${baseUrl}/IMAGES/HELPIMAGES/ZAB/MIN_AUSSENLAENGE.JPG`,
              alt: i18n.t<string>("minAussenlaenge"),
            };
            return imageProps;
          }
          case "minOeffnungsweite": {
            const imageProps: IImageProps = {
              src: `${baseUrl}/IMAGES/HELPIMAGES/ZAB/MIN_OEFFNUNGSWEITE.JPG`,
              alt: i18n.t<string>("minOeffnungsweite"),
            };
            return imageProps;
          }
        }
        break;
    }
  };

  return {
    getImage: (type: string, property: string) => getImage(type, property),
  };
}
